import { render, staticRenderFns } from "./BudgetsV4.vue?vue&type=template&id=e90e4744&scoped=true"
import script from "./BudgetsV4.vue?vue&type=script&lang=js"
export * from "./BudgetsV4.vue?vue&type=script&lang=js"
import style0 from "./BudgetsV4.vue?vue&type=style&index=0&id=e90e4744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90e4744",
  null
  
)

export default component.exports